
const DropdownLoader = () => {
    return (
        <div className={`dropdown-loader`}>
            <div className={`page-loader`}></div>
        </div>
    )
}

export default DropdownLoader